// Static Taiwan city list (legacy TaiwanCities.json). TW ships a fixed dropdown
// rather than a free-text city field; the label shown depends on language.
export interface TaiwanCity {
    /** Romanized name, shown when the UI language is English. */
    city_roman: string
    /** Native (Traditional Chinese) name, shown otherwise. */
    city_native: string
}

export const TAIWAN_CITIES: readonly TaiwanCity[] = [
    { city_roman: 'Nantou County', city_native: '南投縣' },
    { city_roman: 'South Sea Islands', city_native: '南海諸島' },
    { city_roman: 'Chiayi City', city_native: '嘉義市' },
    { city_roman: 'Chiayi County', city_native: '嘉義縣' },
    { city_roman: 'Keelung City', city_native: '基隆市' },
    { city_roman: 'Yilan County', city_native: '宜蘭縣' },
    { city_roman: 'Pingtung County', city_native: '屏東縣' },
    { city_roman: 'Changhua County', city_native: '彰化縣' },
    { city_roman: 'New Taipei City', city_native: '新北市' },
    { city_roman: 'Hsinchu City', city_native: '新竹市' },
    { city_roman: 'Hsinchu County', city_native: '新竹縣' },
    { city_roman: 'Taoyuan City', city_native: '桃園市' },
    { city_roman: 'Penghu County', city_native: '澎湖縣' },
    { city_roman: 'Taichung City', city_native: '臺中市' },
    { city_roman: 'Taipei City', city_native: '臺北市' },
    { city_roman: 'Tainan City', city_native: '臺南市' },
    { city_roman: 'Taitung County', city_native: '臺東縣' },
    { city_roman: 'Hualien County', city_native: '花蓮縣' },
    { city_roman: 'Miaoli County', city_native: '苗栗縣' },
    { city_roman: 'Lianjiang County', city_native: '連江縣' },
    { city_roman: 'Kinmen County', city_native: '金門縣' },
    { city_roman: 'Yunlin County', city_native: '雲林縣' },
    { city_roman: 'Kaohsiung City', city_native: '高雄市' }
]

/** City option labels for the given UI language ('EN' → roman, else native). */
export const taiwanCityOptions = (language: string): { text: string; value: string }[] => {
    const useRoman = language.toUpperCase() === 'EN'
    return TAIWAN_CITIES.map(c => {
        const label = useRoman ? c.city_roman : c.city_native
        return { text: label, value: label }
    })
}
